import { useContext, useEffect } from "react";
import { UsinasContext } from "../context/UsinasContextProvider";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import TextInput from "../../../main/components/TextInput";
import { Grid, Typography } from "@mui/material";

export const schema = yup.object().shape({
  name: yup.string().required("Nome da usina é obrigatório"),
});
export type UpdateIndicatorsData = yup.InferType<typeof schema>;

export const inputSx = {
  width: "100%",
  // maxWidth: "250px",
  maxWidth: "450px",
};
export const UsinaNameEditForm = React.forwardRef(
  (
    props: {
      setNewName: (name: string) => void;
      setOpenConfirmNameEditModal: (open: boolean) => void;
      open: boolean;
      setCanEdit: (canEdit: boolean) => void;
    },
    ref
  ) => {
    const {
      control,
      formState: { errors },
      setValue,
      handleSubmit,
      watch,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const { usina } = useContext(UsinasContext);
    const name = usina?.name;
    const { setNewName, setOpenConfirmNameEditModal, open } = props;
    const data = watch();
    useEffect(() => {
      if (name && data.name !== name) {
        props.setCanEdit(true);
      } else {
        props.setCanEdit(false);
      }
    }, [data]);
    const onMount = () => {
      if (!name) {
        setValue("name", "");
        return;
      }
      setValue("name", name);
    };

    useEffect(() => {
      if (open) onMount();
    }, [open]);

    const onSubmit = (data: UpdateIndicatorsData) => {
      const newName: string | undefined =
        data.name !== name ? data.name : undefined;
      if (newName) {
        setNewName(newName);
        setOpenConfirmNameEditModal(true);
      }
    };
    React.useImperativeHandle(ref, () => ({
      async submitForm() {
        await handleSubmit(onSubmit)();
      },
    }));
    return (
      <Grid
        component="form"
        container
        onSubmit={handleSubmit(onSubmit)}
        spacing={2}
        sx={{ width: "100%" }}
      >
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: "bold" }}>Nome da Usina</Typography>
        </Grid>
        <Grid item xs={12}>
          <TextInput
            control={control}
            errors={errors}
            fieldName="name"
            label=""
            sx={inputSx}
          />
        </Grid>
      </Grid>
    );
  }
);
